// Client-side promo validity check.
//
// The SERVER (validatePromo in functions/index.js) is authoritative. This mirror
// exists so the UI never shows a discount the server will refuse — otherwise the
// customer sees a discounted total and is then charged the full amount at Stripe.
//
// Keep this in sync with functions/index.js -> validatePromo().
// (perCustomer can't be checked client-side — that needs the redemption history —
// so the server may still reject a code the UI accepted. That's a safe direction:
// worst case the customer is told the code didn't apply BEFORE paying.)
export function isPromoValidNow(promo, today = new Date().toISOString().slice(0, 10)) {
  if (!promo || promo.active !== true) return false;
  if (promo.start && today < promo.start) return false; // not started
  if (promo.end && today > promo.end) return false; // expired
  if (promo.usageLimit && (promo.timesUsed || 0) >= promo.usageLimit) return false; // used up
  return true;
}

// Which cart lines a promo applies to. `products` (product ids) takes precedence
// over `categories` (category slugs); if neither is set the promo applies to the
// whole cart. Keep in sync with functions/index.js -> eligibleSubtotal().
export function isLineEligible(promo, line) {
  const products = promo.products || [];
  const categories = promo.categories || [];
  const productId = line.productId ?? line.product?.id;
  const category = line.product?.category ?? line.category;
  if (products.length) return products.includes(productId);
  if (categories.length) return categories.includes(category);
  return true;
}

// Sum of eligible line totals — the base a restricted promo discounts. For an
// unrestricted promo this equals the full subtotal (unchanged behaviour).
export function eligibleSubtotal(promo, detailed) {
  return (detailed || []).reduce(
    (sum, line) => (isLineEligible(promo, line) ? sum + (line.lineTotal || 0) : sum),
    0
  );
}
